import React from 'react';

import './styles.css';

export default class Map extends React.Component {
  render() {
    return (
      <div className="Content Content__no-padding" ref="dom">
        <h2 className="Title Title__center" id="stadsetning">Staðsetning</h2>
        <div className="Map">
          <div className="Map-title-container">
            <h3 className="Title Title__small Title__center">Viðarhöfði 1</h3>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/map/index.js